/**
 * Schneidet Leerzeichen-Ränder aller Textfelder ab — rekursiv durch Objekte
 * und Arrays, ohne das Original zu verändern.
 *
 * Warum im Formular und nicht beim Import: Trailing Spaces sind im USP ein
 * bekannter Datenfehler (Bartek beanstandete sie 11/2025 für `famname`) und
 * können die behördliche Vorprüfung stören. Beim Import fällt so etwas nur
 * auf, wenn jemand genau hinsieht — hier kostet es nichts. Ausgelöst durch
 * Antrag #11 (Danler, 18.08.2026): `info: "Fluglehrer "`.
 *
 * Nicht-Strings (Zahlen, null, Booleans) bleiben unangetastet, damit
 * `id: null`, `art: 0` und `upload: true` unverändert in die zuep.json gehen.
 */
export function trimTiefe<T>(wert: T): T {
  if (typeof wert === 'string') {
    return wert.trim() as unknown as T;
  }
  if (Array.isArray(wert)) {
    return wert.map((eintrag) => trimTiefe(eintrag)) as unknown as T;
  }
  if (wert !== null && typeof wert === 'object') {
    const kopie: Record<string, unknown> = {};
    for (const [schluessel, inhalt] of Object.entries(wert as Record<string, unknown>)) {
      kopie[schluessel] = trimTiefe(inhalt);
    }
    return kopie as unknown as T;
  }
  return wert;
}
